import { Divider, HStack, Button, useBreakpointValue } from '@chakra-ui/react'
import {
    Drawer,
    DrawerBody,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
  } from '@chakra-ui/react'
import { IApiContactResponse } from '../../../models/api/contact/IApiContactResponse';
import { ContactSearch } from '../../ContactSearch/ContactSearch';
import { Autocomplete } from '../../Autocomplete/Autocomplete';
import { AutocompleteContactHit } from '../../Autocomplete/AutocompleteContactHit';

export interface IContactSearchDrawerConfig {
    onSubmit?(data: IApiContactResponse): void;
}

export interface IContactSearchDrawerProps extends IContactSearchDrawerConfig {
    headerText?: string;
    discardText?: string;
    clear(): void;
}

export const ContactSearchDrawer = ({ onSubmit, headerText, discardText, clear }: IContactSearchDrawerProps) => {
    const isPhone = useBreakpointValue({ base: true, md: false });

    return (
        <Drawer
            isOpen={onSubmit !== undefined}
            placement='right'
            onClose={clear}
            size={isPhone ? 'full' : 'md'}
            closeOnOverlayClick={false}
            closeOnEsc={false}
        >
            <DrawerOverlay />
            <DrawerContent h="full">
                <DrawerHeader>
                    <HStack justifyContent="space-between">
                        <span>
                            {headerText ?? "Kontakt suchen"}
                        </span>
                        {/*
                        <IconButton
                            icon={<FiX fontSize="1.25rem" />}
                            variant="ghost"
                            aria-label="Discard"
                            onClick={clear}
                        />
                        */}
                    </HStack>
                </DrawerHeader>
                <Divider />
                <DrawerBody px="4">
                    <Autocomplete<IApiContactResponse> 
                        sourceId='contacts' 
                        indexName='dev_contacts' 
                        itemTemplate={props => (<AutocompleteContactHit {...props} onClick={() => onSubmit && onSubmit(props.item)} />)} />
                </DrawerBody>
                <DrawerFooter px="4">
                    <Button variant='secondary' onClick={clear} w="full">
                        {discardText ?? "Abbrechen"}
                    </Button>
                </DrawerFooter>
            </DrawerContent>
        </Drawer>
    );
}